import { styled } from 'styled-components'

import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

export const TableContainer = styled.div`
  display: grid;
  grid-template-columns: 18rem 1fr;
  grid-gap: 1.5rem;
  @media ${Breakpoints.max.medium} {
    grid-template-columns: 1fr;
  }

  /* Remove any borders on tablet/mobile */
  @media ${Breakpoints.max.medium} {
    border: none !important;
    box-shadow: none !important;
    border-image: none !important;
    outline: none !important;
    &::after,
    &::before {
      display: none !important;
      content: none !important;
      border: none !important;
      box-shadow: none !important;
      background: none !important;
    }
    & > * {
      border-top: none !important;
      border-bottom: none !important;
      border: none !important;
      box-shadow: none !important;
      &::after,
      &::before {
        display: none !important;
        content: none !important;
        border: none !important;
        background: none !important;
      }
    }
    /* Target h2 title specifically */
    & > h2 {
      border: none !important;
      border-bottom: none !important;
      box-shadow: none !important;
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
      &::after,
      &::before {
        display: none !important;
        content: none !important;
        border: none !important;
        background: none !important;
        height: 0 !important;
        width: 0 !important;
      }
    }
  }
`

export const Pair = styled.div``

export const Table = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  grid-gap: 2rem;
  ${Pair} {
    &:nth-child(-n + 3) {
      grid-row: 1;
    }
    &:nth-child(n + 4):nth-child(-n + 6) {
      grid-row: 2;
    }
    &:nth-child(7) {
      grid-row: 3;
      grid-column: 1/-1;
    }
    &:nth-child(8) {
      grid-area: 4 / 1 / auto / -1;
    }
  }
`

export const DetailsValue = styled.div`
  position: relative;
  ${Typography.Body2}
`

export const DetailsTitle = styled.h2`
  color: ${designColors.neutral.darkGray};
  ${Typography.Body3}
  margin: 0;
  padding: 0;
`

export const Title = styled.h2`
  ${Typography.Title2}
  color: ${Colors.Semantic.Neutral.black};
  margin: 0;
  padding: 0;
  @media ${Breakpoints.max.small} {
    display: none;
  }

  /* Remove any border/line on tablet and mobile view */
  @media ${Breakpoints.max.medium} {
    border-bottom: none !important;
    border-top: none !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    &::after,
    &::before {
      display: none !important;
      content: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  /* More aggressive override for any parent container borders */
  @media ${Breakpoints.max.medium} {
    & + *,
    & + div,
    & ~ * {
      border-top: none !important;
      box-shadow: none !important;
    }
  }

  /* Target the parent TableContainer to remove any borders around Title */
  @media ${Breakpoints.max.medium} {
    position: relative;
    z-index: 1;
    background-color: white;
  }
`
